let counter = 0;

/** Short, collision-safe ids for window instances. */
export function newId(prefix = 'w'): string {
  counter += 1;
  return `${prefix}${counter.toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}
